import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RecurringByDayOfWeekComponent } from './recurring-by-day-of-week.component';

@NgModule({
	imports: [
		ComboComponentModule,
		CommonModule,
		ContainerComponentModule,
		DynamicComponentLoaderModule.forChild(RecurringByDayOfWeekComponent),
		InputComponentModule,
		SignpostComponentModule,
		TextComponentModule,
		ToggleSwitchComponent,
	],
	declarations: [
		RecurringByDayOfWeekComponent
	],
	exports: [
		RecurringByDayOfWeekComponent
	]
})
export class RecurringByDayOfWeekModule { }
